// extracted by mini-css-extract-plugin
export default {"container":"code_container__+FRDA","nameSection":"code_nameSection__o9rKq","codeSection":"code_codeSection__Lj6Kn"};